/* eslint-disable */
import { CONFIG } from "~/config";
import Avatar from "./avatar";

interface IHeroHeaderOptions {
	title: string | HTMLElement | DocumentFragment;
	className: string;
	poster: string;
	totalInfoHTML: string;
}

export default class HeroHeader {
	_container: HTMLDivElement;
	_poster: HTMLImageElement;
	_titleContainer: HTMLDivElement;
	_title: HTMLParagraphElement;
	_toolbar: HTMLDivElement;
	_leftButtons: HTMLDivElement;
	_rightButtons: HTMLDivElement;
	_totalInfo: HTMLParagraphElement;

	constructor({
		title = "",
		className = "",
		poster = "/img/header-placeholder.svg",
		totalInfoHTML = "",
	}: Partial<IHeroHeaderOptions>) {
		this._container = Mapy.Util.node("div", { className: `ui-heroheader ${className}` }) as HTMLDivElement;
		this._poster = Mapy.Util.node("img", { className: "ui-heroheader__poster", src: poster }) as HTMLImageElement;

		if (CONFIG.wasmEnabled) {
			this._poster.crossOrigin = "anonymous";
		}

		this._title = Mapy.Util.node("p", { className: "ui-heroheader__title" }) as HTMLParagraphElement;
		this.title = title;
		this._toolbar = Mapy.Util.node("div", { className: "ui-heroheader__toolbar" }) as HTMLDivElement;
		this._leftButtons = Mapy.Util.node("div", { className: "ui-heroheader__left-buttons" }) as HTMLDivElement;
		this._rightButtons = Mapy.Util.node("div", { className: "ui-heroheader__right-buttons" }) as HTMLDivElement;
		this._totalInfo = Mapy.Util.node("p", { className: "ui-heroheader__totalInfo", innerHTML: totalInfoHTML }) as HTMLParagraphElement;
		this._container.appendChild(this._poster);
		this._container.appendChild(this._title);
		this._container.appendChild(this._totalInfo);
		this._container.appendChild(this._toolbar);
		this._toolbar.appendChild(this._leftButtons);
		this._toolbar.appendChild(this._rightButtons);
	}

	set title(title: string | HTMLElement | DocumentFragment) {
		if (typeof title === "string") {
			this._title.textContent = title;
		} else {
			Mapy.Util.clear(this._title);
			this._title.appendChild(title);
		}
	}

	set poster(poster: string) {
		this._poster.src = poster;
	}

	set totalInfoHTML(totalInfoHTML: string) {
		this._totalInfo.innerHTML = totalInfoHTML;
	}

	get node() {
		return this._container;
	}

	get leftButtons() {
		return this._leftButtons;
	}

	get rightButtons() {
		return this._rightButtons;
	}
}
